import { Seo } from "@/components/Seo";
import { Reveal, Panel, Tag, KV } from "@/components/System";
import { LINKS } from "@/data/content";

const NA = "DATA NOT AVAILABLE";

const Token = () => (
    <div>
        <Seo path="/token" />
        <section className="relative overflow-hidden px-4 pb-24 pt-36 sm:px-6">
            <div className="vm-grid-bg pointer-events-none absolute inset-0 opacity-30" aria-hidden="true" />
            <div className="relative mx-auto max-w-5xl">
                <div className="vm-micro mb-6">AGENTVM://TOKEN</div>
                <h1 className="text-5xl font-bold tracking-tight text-[#F5F9FF] sm:text-7xl">
                    <span className="text-[#00D9FF] vm-glow">$</span>AGENTVM
                </h1>
                <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#B8C7D9] sm:text-lg">
                    Token telemetry for the AgentVM network asset on Arc. Where market data is not available from an
                    official source, this console says so — no invented numbers.
                </p>

                <div className="mt-12 grid gap-5 lg:grid-cols-[1.1fr_1fr]">
                    <Panel title="TOKEN://IDENTITY" right="ARC NETWORK" testid="token-identity">
                        <div className="p-6 sm:p-8">
                            <KV k="TOKEN" v="$AGENTVM" tone="cyan" />
                            <KV k="NETWORK" v="ARC" tone="cyan" />
                            <KV k="CONTRACT ADDRESS" v={NA} />
                            <div className="mt-6 flex flex-wrap gap-3">
                                <a
                                    href={LINKS.buy}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="token-buy"
                                    className="border border-[#1688FF]/70 bg-[#006CFF]/25 px-5 py-2.5 font-mono text-[11px] tracking-[0.24em] text-[#F5F9FF] transition-colors hover:bg-[#006CFF]/45"
                                >
                                    BUY $AGENTVM ↗
                                </a>
                                <span
                                    data-testid="token-chart"
                                    title="PAIR DATA NOT AVAILABLE"
                                    className="cursor-not-allowed border border-[rgba(0,217,255,0.2)] px-5 py-2.5 font-mono text-[11px] tracking-[0.24em] text-[#B8C7D9]/40"
                                >
                                    CHART — {NA}
                                </span>
                            </div>
                        </div>
                    </Panel>

                    <Panel title="TOKEN://TELEMETRY" right={<Tag tone="concept">UNAVAILABLE</Tag>} testid="token-telemetry">
                        <div className="p-6 sm:p-8">
                            <KV k="SUPPLY" v={NA} />
                            <KV k="MARKET CAP" v={NA} />
                            <KV k="HOLDERS" v={NA} />
                            <KV k="LIQUIDITY" v={NA} />
                            <KV k="VOLUME 24H" v={NA} />
                            <p className="vm-micro-dim mt-6 leading-relaxed">
                                METRICS APPEAR ONLY WHEN SOURCED FROM AN OFFICIAL FEED.
                            </p>
                        </div>
                    </Panel>
                </div>

                <Reveal delay={0.1}>
                    <div className="vm-panel-soft mt-8 p-5">
                        <p className="text-xs leading-relaxed text-[#B8C7D9]/80 sm:text-sm">
                            <span className="font-mono tracking-[0.14em] text-[#F5F9FF]">NOTE.</span> $AGENTVM is the
                            AgentVM project asset. Nothing on this page states or implies that $AGENTVM is the official
                            token of the Arc network or Circle. This site does not provide financial advice.
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    </div>
);

export default Token;
